export default class TweenedText extends Phaser.GameObjects.Text {
    private _tween: Phaser.Tweens.Tween;
    private _config: any;
    private _y: number;
    private _x: number;
    private _Y:string;
    private _tweenEndCallBack: Function;
    constructor(scene, x, y, text, Y?:number, scale?:number, alpha?:number, style?: any, duration?: number, easing?, tweenEndCallBack?: Function) {
        super(scene, x, y, text, style);
        // this.setFontSize(fontSize || 50);
        // this.setFontFamily(fontFamily || "font_2");
        this._tweenEndCallBack = tweenEndCallBack || function(){};
        // this._tween.stop();
        // this.setZ(100)
        this.setOrigin(0.5, 0.5);
        this.scene.add.existing(this);
        this._config = {
            targets: this,
            // alpha: { from: 1, to: 0 },
            callbackScope: this,
            onComplete: this._onTweenComplete,
            // y: "-="+Math.floor(window.constants.BASE_HEIGHT / 10),
            ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
            duration: (duration != undefined) ? duration : 1500,
            repeat: 0,            // -1: infinity
            yoyo: false
        }
        if(alpha != null) {
            this._config.alpha = { from: 1, to: alpha}
        }
        if(scale != null){
            this._config.scale = { from: 1, to: scale}
            this._config.ease = (easing != undefined)? easing : Phaser.Math.Easing.Bounce.Out;
            delete this._config.alpha;
        }
        if(Y != null) {
            this._Y = "+="+Y; 
        }
        this._x = x; this._y = y;
        this.stop();
    }
    
    public start(x?:number, y?:number, text?:string) {
        this.setActive(true);
        this.setVisible(true);
        if(text != undefined) {
            this.setText(text);
        }
        this.setScale(1);
        this.setAlpha(1);
        if(x != null) {
            this.setPosition(x, y);
        }
        else {
            this.setPosition(this._x, this._y);
        }
        if(this._Y) {
            this._config.y = this._Y;
        }
        this._tween = this.scene.add.tween(this._config);
        // console.log(this.x);
        // this._tween.restart();
    }

    public stop(){
        // console.log(this.y);
        this.setActive(false);
        this.setVisible(false);
        this.setPosition(window.constants.DEAD_SPOT.x, window.constants.DEAD_SPOT.y);
        if(this._tween)
        {
            this.scene.tweens.remove(this._tween);
            this._tween = null;
        }
    }

    private _onTweenComplete(){
        this.stop();
        this._tweenEndCallBack();
    }   

    update(time, dt) {
    }
}